export default function Footer() {
  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>, href: string) => {
    e.preventDefault();
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer id="footer" className="bg-foreground-900 text-background-50/80">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-12 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-10">
          <div className="sm:col-span-2 lg:col-span-1">
            <a
              href="#hero"
              onClick={(e) => handleClick(e, '#hero')}
              className="text-xl font-heading font-bold text-background-50 hover:text-primary-300 transition-colors cursor-pointer inline-block mb-3"
            >
              歪歪漫画网
            </a>
            <p className="text-sm leading-relaxed text-background-50/60">
              歪歪漫画网是专业的漫画免费在线阅读平台，提供歪歪漫画网站入口与歪歪漫画免费网站入口，聚合日漫韩漫国漫大全资源。支持下拉式全集阅读模式，每日同步更新热门连载，为漫画爱好者提供便捷的在线免费阅读体验。
            </p>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">快速导航</h4>
            <div className="flex flex-col gap-2.5">
              {[
                { label: '本站特色', href: '#features' },
                { label: '精选专题', href: '#carousel' },
                { label: '人气排行', href: '#ranking' },
                { label: '移动阅读', href: '#app' },
                { label: '常见问题', href: '#faq' },
              ].map((link) => (
                <a
                  key={link.href}
                  href={link.href}
                  onClick={(e) => handleClick(e, link.href)}
                  className="text-sm text-background-50/60 hover:text-primary-300 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">漫画分类</h4>
            <div className="flex flex-col gap-2.5">
              {['热门日漫', '超火韩漫', '国漫大全', '热血战斗', '恋爱甜宠', '悬疑推理'].map((cat) => (
                <span key={cat} className="text-sm text-background-50/60 cursor-pointer hover:text-primary-300 transition-colors">
                  {cat}
                </span>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-sm font-heading font-bold text-background-50 mb-4">合作伙伴</h4>
            <p className="text-sm text-background-50/60 leading-relaxed">
              歪歪漫画网与多家优质漫画平台及内容提供商保持合作，持续为读者带来更丰富的漫画阅读资源与更优质的阅读体验。
            </p>
          </div>
        </div>

        <div className="border-t border-background-50/10 mt-10 pt-6 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-background-50/40">
            &copy; {new Date().getFullYear()} 歪歪漫画网 - 免费漫画在线阅读平台
          </p>
          <div className="flex items-center gap-4 text-xs text-background-50/40">
            <span>歪歪漫画网站入口</span>
            <span>歪歪漫画免费入口</span>
          </div>
        </div>
      </div>
    </footer>
  );
}